import React, { useState, useContext, useEffect } from "react"
import { UserContext } from "../../../context/userContext"
import { gql, useLazyQuery, useQuery } from "@apollo/client"
import _ from "lodash"
import { MultiSelect } from "primereact/multiselect"
import trcss from "../../../styles/Telerecovery.module.css"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { InputTextarea } from "primereact/inputtextarea"
import { Button } from "primereact/button"
import { GET_PROGRAMS } from "../../Programs/queries"
import { Dialog } from "primereact/dialog"
import "primeicons/primeicons.css"
import { Tooltip } from "primereact/tooltip"
import { Badge } from "@material-ui/core"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { FilterMatchMode } from "primereact/api"
import { trApiSendBroadcastSMS } from "../telerecoveryApi"

export default function BroadcastNew({ onMessageSent }) {
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [newSMSText, setNewSMSText] = useState("")
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const [selectedGroupFilter, setSelectedGroupFilter] = useState([])
  const [selectedParticipants, setSelectedParticipants] = useState([])
  const [groupName, setGroupName] = useState("")
  const [selectedProgram, setSelectedProgram] = useState(null)
  const [sendingMessage, setSendingMessage] = useState(false)
  const [newBroadcastResponse, setNewBroadcastResponse] = useState(null)

  const [filters] = useState({
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const GET_PARTICIPANT_BY_PROGRAM = gql`
    query participantsByProgram(
      $staff_id: ID!
      $program_identity_id: ID!
      $condiction: Boolean
    ) {
      participantsByProgram: participantsByProgram(
        staff_id: $staff_id
        program_identity_id: $program_identity_id
        condiction: $condiction
      ) {
        participant_id
        participant_alias
        participant_name_first
        participant_name_last
        participant_membership_status
        participant_name_preferred
        participant_phone_primary
      }
    }
  `
  let GET_ORG_PARTICIPANTS = gql`
    query ParticipantsSidebar($staff_id: ID!, $organization_id: ID!) {
      participants: getAllActiveParticipants(
        staff_id: $staff_id
        organization_id: $organization_id
        search_type: "all_participants"
      ) {
        participant_id
        participant_membership_status
        participant_name_first
        participant_name_last
        participant_phone_primary
      }
    }
  `
  let GET_STAFF_ASSIGNED_PARTICIPANTS = gql`
    query ParticipantsSidebar($staff_id: ID!, $organization_id: ID!) {
      participants: getAllActiveParticipants(
        staff_id: $staff_id
        organization_id: $organization_id
        search_type: "my_participants"
      ) {
        participant_id
        participant_membership_status
        participant_name_first
        participant_name_last
        participant_phone_primary
      }
    }
  `
  const { loading: loading_org_participants } = useQuery(GET_ORG_PARTICIPANTS, {
    variables: {
      staff_id: user.staff_id,
      organization_id: user.organization_id,
    },
    context: {
      headers: {
        //userCtx: JSON.stringify(userCtx),
      },
    },
    skip: !user,
    fetchPolicy: "network-only",
    onCompleted: ({ participants }) => {
      const newParticipantList = _.map(participants, (participant) => {
        return {
          participant_id: participant.participant_id,
          participant_phone_primary: participant.participant_phone_primary,
          name: `${_.unescape(participant.participant_name_first)} ${_.unescape(
            participant.participant_name_last,
          )}`,
        }
      })

      return setOrgParticipantsList(
        newParticipantList.filter((s) => s.participant_phone_primary),
      )
    },
  })

  const { loading: loading_assigned_participants } = useQuery(
    GET_STAFF_ASSIGNED_PARTICIPANTS,
    {
      variables: {
        staff_id: user.staff_id,
        organization_id: user.organization_id,
      },
      context: {
        headers: {
          //userCtx: JSON.stringify(user),
        },
      },
      skip: !user,
      fetchPolicy: "network-only",
      onCompleted: ({ participants }) => {
        const newParticipantList = _.map(participants, (participant) => {
          return {
            participant_id: participant.participant_id,
            participant_phone_primary: participant.participant_phone_primary,
            name: `${_.unescape(participant.participant_name_first)} ${_.unescape(
              participant.participant_name_last,
            )}`,
          }
        })

        return setStaffAssignedParticipantsList(
          newParticipantList.filter((s) => s.participant_phone_primary),
        )
      },
    },
  )

  const [loadParticipantsByProgram] = useLazyQuery(GET_PARTICIPANT_BY_PROGRAM, {
    variables: {
      staff_id: user.staff_id,
      program_identity_id: selectedProgram?.program_id,
      condiction: true,
    },
    context: {
      headers: {
        //userCtx: JSON.stringify(userCtx),
      },
    },
    skip: !selectedProgram,
    fetchPolicy: "network-only",
    onCompleted: ({ participantsByProgram }) => {
      const newParticipantList = _.map(participantsByProgram, (participant) => {
        return {
          participant_id: participant.participant_id,
          participant_phone_primary: participant.participant_phone_primary,
          name: `${_.unescape(participant.participant_name_first)} ${_.unescape(
            participant.participant_name_last,
          )}`,
        }
      })

      return setSelectedProgramParticipantsList(
        newParticipantList.filter((s) => s.participant_phone_primary),
      )
    },
    onError: (err) => console.log(err),
  })

  useEffect(() => {
    if (selectedProgram) {
      loadParticipantsByProgram()
    }
  }, [selectedProgram])

  useQuery(GET_PROGRAMS, {
    variables: {
      staff_id: user?.staff_id,
      organization_id: user?.organization_id,
    },
    context: {
      headers: {
        // "userCtx": JSON.stringify(userCtx)
      },
    },
    skip: !user.staff_id,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const programs = data.programs
        .filter((p) => p.organization_id === user.organization_id)
        .map((program) => {
          return {
            program_id: program.program_identity_id,
            program_name: program.program_id_name,
          }
        })

      setProgramList(programs)
    },
  })

  const [orgParticipantsList, setOrgParticipantsList] = useState(null)
  const [staffAssignedParticipantsList, setStaffAssignedParticipantsList] =
    useState(null)
  const [selectedProgramParticipantsList, setSelectedProgramParticipantsList] =
    useState(null)
  const [programList, setProgramList] = useState([])
  const [filterOptions] = useState([
    {
      name: "Individual selection (Min: 2 - Max: 50)",
      value: "individual_selection",
    },
    {
      name: "Send to all my assigned participants",
      value: "assigned_participants",
    },
    //{name: "Send to all active organization participants", value: "active_organization_participants"},
    {
      name: "Send to all active participants in a specific program",
      value: "participants_by_program",
    },
  ])

  const sendMessage = () => {
    if (
      newSMSText === "" ||
      groupName === "" ||
      sendingMessage ||
      (filterOptions === "individual_selection" &&
        (!selectedParticipants || selectedParticipants.length < 2)) ||
      (filterOptions === "participants_by_program" && !selectedProgram)
    ) {
      return
    }

    var broadcastMessage = {
      soarGroupId: user.organization_id,
      toParticipantList: selectedParticipants,
      body: newSMSText,
      groupName: groupName,
      createdByStaffId: user.staff_id,
      selectedFilter: "individual_selection", //selectedGroupFilter,
      orgAlias: user.organization_alias,
      programId: selectedProgram?.program_id,
    }

    setSendingMessage(true)

    trApiSendBroadcastSMS(
      userCtx.tokens.getTelerecoveryToken(),
      broadcastMessage,
    ).then(
      (response) => {
        setSendingMessage(false)
        setNewSMSText("")
        setIsDialogOpen(true)

        setNewBroadcastResponse(response)
      },
      (err) => {
        console.log(err)
        //alert("Sending broadcast failed.")
        setSendingMessage(false)
      },
    )
  }

  const updateSelectedFilter = (selectedFilter) => {
    setSelectedParticipants(null)
    setSelectedProgram(null)
    setSelectedProgramParticipantsList(null)
    setSelectedGroupFilter(selectedFilter)
  }

  useEffect(() => {
    if (selectedGroupFilter === "assigned_participants") {
      setSelectedParticipants(staffAssignedParticipantsList)
    } else if (selectedGroupFilter === "participants_by_program") {
      setSelectedParticipants(selectedProgramParticipantsList)
    }
  }, [
    selectedGroupFilter,
    staffAssignedParticipantsList,
    selectedProgramParticipantsList,
  ])

  const onMessageSentInternal = () => {
    console.log(newBroadcastResponse)
    if (newBroadcastResponse && newBroadcastResponse.totalSMSSent > 0) {
      onMessageSent(newBroadcastResponse?.broadcastGroup)
    } else {
      setIsDialogOpen(false)
    }
  }

  return (
    <div className={trcss.chatWrapper}>
      <div className={gMessages.newChatForm}>
        <h2>New Organization Message</h2>
        <hr />
        <div className={gMessages.content} style={{ height: "auto" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "50% 50%",
              width: "100%",
              gridGap: "10px",
              padding: "0 10px 0 0",
            }}
          >
            <div className={gMessages.field} style={{ width: "100%" }}>
              <label className={gMessages.label} htmlFor="groupName">
                Broadcast Name
                <Tooltip target=".broadcastName" className="custom-tooltip" />
                <i
                  className="broadcastName pi pi-info-circle p-text-secondary p-overlay-badge"
                  data-pr-tooltip="Please name your broadcast for easy identification in the broadcast history."
                  data-pr-position="right"
                  data-pr-at="right+5 top"
                  data-pr-my="left center-2"
                  style={{
                    color: "#883cae",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                >
                  <Badge severity="info"></Badge>
                </i>
              </label>
              <InputText
                value={groupName}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                  textAlign: "left",
                }}
                onChange={(e) => setGroupName(e.target.value)}
              />
            </div>
            <div className={gMessages.field} style={{ width: "100%" }}>
              <label className={gMessages.label} htmlFor="groupFilter">
                Participant(s) Selection
                <Tooltip
                  target=".custom-target-icon"
                  className="custom-tooltip"
                />
                <i
                  className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                  data-pr-tooltip="You may select participants at your organization using the filters below to send a broadcasted message. Group messages will go as single messages to each included participant and any responses will come to their individual conversation history with you. Broadcasts cannot be used for group conversations, only broadcast single time messages."
                  data-pr-position="right"
                  data-pr-at="right+5 top"
                  data-pr-my="left center-2"
                  style={{
                    color: "#883cae",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                >
                  <Badge severity="info"></Badge>
                </i>
              </label>
              <Dropdown
                value={selectedGroupFilter}
                onChange={(e) => updateSelectedFilter(e.value)}
                options={filterOptions}
                optionLabel="name"
                className={gMessages.selector}
                placeholder="Select filter"
              />
            </div>
            {selectedGroupFilter === "participants_by_program" && (
              <div className={gMessages.field} style={{ width: "100%" }}>
                <label className={gMessages.label} htmlFor="programId">
                  Program ID
                </label>
                <Dropdown
                  value={selectedProgram}
                  onChange={(e) => setSelectedProgram(e.value)}
                  options={programList}
                  optionLabel="program_name"
                  className={gMessages.selector}
                  placeholder="Select Program"
                />
              </div>
            )}
            {selectedGroupFilter === "individual_selection" && (
              <div className={gMessages.field} style={{ width: "100%" }}>
                <label htmlFor="participants" className={gMessages.label}>
                  Select one or more participants
                </label>
                <MultiSelect
                  value={selectedParticipants}
                  onChange={(e) => setSelectedParticipants(e.value)}
                  options={orgParticipantsList}
                  selectionLimit={50}
                  optionLabel="name"
                  filter
                  className={gMessages.selector}
                  placeholder="Select participants"
                />
              </div>
            )}
          </div>
          {(selectedGroupFilter === "assigned_participants" ||
            (selectedGroupFilter === "participants_by_program" &&
              selectedProgram)) &&
            loading_assigned_participants === false &&
            loading_org_participants === false && (
              <div className={gMessages.field} style={{ width: "100%" }}>
                <label className={gMessages.label}>Recipients</label>
                <DataTable
                  className="tr-participantslist"
                  value={
                    selectedGroupFilter === "assigned_participants"
                      ? staffAssignedParticipantsList
                      : selectedProgramParticipantsList
                  }
                  //tableStyle={{ minWidth: '50rem' }}
                  scrollable
                  scrollHeight="450px"
                  sortField="name"
                  sortOrder={1}
                  filters={filters}
                  filterDisplay="row"
                  loading={
                    loading_org_participants || loading_assigned_participants
                  }
                >
                  <Column
                    field="name"
                    header="Name"
                    filter
                    filterPlaceholder="Search by name"
                  ></Column>
                  <Column
                    field="participant_phone_primary"
                    header="Phone Number"
                  ></Column>
                </DataTable>
              </div>
            )}
          <div className={trcss.chatWindowFooter} style={{ marginTop: "50px" }}>
            <InputTextarea
              placeholder="Type your message"
              autoResize
              className={trcss.newMessageBox}
              value={newSMSText}
              onChange={(e) => setNewSMSText(e.target.value)}
              rows={1}
              disabled={
                !selectedParticipants || sendingMessage || groupName === ""
              }
            />
            <div style={{ display: "flex", alignItems: "end" }}>
              <Button className={trcss.sendBtn} onClick={() => sendMessage()} />
            </div>
          </div>
        </div>
      </div>

      <Dialog
        header={() => (
          <div style={{ paddingLeft: "10px" }}>
            <h4
              style={{
                margin: 0,
                marginBottom: "15px",
                color: "#757575",
                fontSize: "20px",
              }}
            >
              Broadcast Result
            </h4>
          </div>
        )}
        visible={isDialogOpen}
        onHide={() => setIsDialogOpen(false)}
        style={{ width: "25%" }}
        headerStyle={{ paddingBottom: "0px" }}
        footer={() => (
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              label="OK"
              type="submit"
              onClick={() => onMessageSentInternal()}
            />
          </div>
        )}
      >
        {newBroadcastResponse && (
          <div>
            <h3>
              Participants Matched:{" "}
              {newBroadcastResponse.totalParticipantsMatched}
            </h3>
            <h3>
              Participants with Primary Phone:{" "}
              {newBroadcastResponse.totalParticipantsWithPrimaryPhone}
            </h3>
            <h3>
              Participants who received the SMS:{" "}
              {newBroadcastResponse.totalSMSSent}
            </h3>
            {newBroadcastResponse.totalSMSSent < 1 && (
              <h3 style={{ fontStyle: "bold" }}>
                The broadcast group was not created.
              </h3>
            )}
          </div>
        )}
      </Dialog>
    </div>
  )
}
